import React, { forwardRef } from 'react';
import styles from './select.module.css';

// Extend the props to include all input attributes
// interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Select = forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => {
  return (
    <select
      className={`${styles.select} ${className}`}
      {...props} // Spread all props, allowing standard input attributes
      ref={ref}
    >
      {children}
    </select>
  );
});
